import { createSelector } from 'reselect';

const getRoutesList = (state) => state.routes.list;
const getUser = (state) => state.user.user;

export const selectRoutesList = createSelector([getRoutesList, getUser], (routes, user) =>
  user?.userType === 3 ? routes.filter((item) => item.id !== 'reports') : routes,
);
